import { RemoveAcentos } from "../../utils/helpers/Format";
import { format, isValid } from "date-fns";

export default function getFilterData(values) {
  const {
    selectedEstados,
    selectedMunicipios,
    selectedBairros,
    selectedDDD,
    faixaEtaria,
    percentualDesconto,
    genre,
    status,
    termometro,
    selectedDocumento,
    selectedTagOrigem,
    selectedProfissao,
    selectedMesNascimento,
    dataCompraInicio,
    dataCompraFim,
    dataCadastroInicio,
    dataCadastroFim,
    categoria_1,
    categoria_2,
    categoria_3,
    categoria_4,
    categoria_5,
    categoria_6,
    categoria_7,
    categoria_8,
    categoria_9,
    categoria_10,
    categoria_11,
    categoria_12,
    n_categoria_1,
    n_categoria_2,
    n_categoria_3,
    n_categoria_4,
    n_categoria_5,
    n_categoria_6,
    n_categoria_7,
    n_categoria_8,
    n_categoria_9,
    n_categoria_10,
    pesquisa_1,
    pesquisa_2,
    pesquisa_3,
    pesquisa_4,
    pesquisa_5,
    celular,
    telefone,
    endereco,
    aniversarioHoje,
    aniversarioMes,
    email,
    valorComprasInicio,
    valorComprasFim,
    qtdeComprasInicio,
    qtdeComprasFim,
    ticketMedioInicio,
    ticketMedioFim,
    diasCadastroInicio,
    diasCadastroFim,
    diasCompraInicio,
    diasCompraFim,
    cashbackInicio,
    cashbackFim,
    dataInicioVencimentoCashback,
    dataFimVencimentoCashback,
    diasVencimentoCashback,
    selectedStores,
    canalPreferecia,
    canalAceito,
    tipoCampanha,
    sensibilidade_sms,
    sensibilidade_email,
    sensibilidade_push,
    sensibilidade_whatsapp,
    nomeConsumidor,
  } = values;

  const objParameters = {
    nome: nomeConsumidor,
    cidades: selectedMunicipios
      ? selectedMunicipios.map((municipio) => RemoveAcentos(municipio.cidade))
      : [],
    estados: selectedEstados
      ? selectedEstados.map((estado) => estado.value)
      : [],
    bairros: selectedBairros
      ? selectedBairros.map((bairro) => bairro.bairro)
      : [],
    ddd: selectedDDD ? selectedDDD.map((ddd) => ddd.DDD) : [],

    store: selectedStores ? selectedStores.map((str) => str.value) : [],
    faixaEtaria: faixaEtaria,
    percentualDesconto: percentualDesconto,
    genre: genre ? genre.split(",") : [],
    termometro: termometro ? termometro : [],
    tipoCampanha: tipoCampanha ? tipoCampanha : [],
    sensibilidade_sms: sensibilidade_sms ? sensibilidade_sms : [],
    sensibilidade_email: sensibilidade_email ? sensibilidade_email : [],
    sensibilidade_push: sensibilidade_push ? sensibilidade_push : [],
    sensibilidade_whatsapp: sensibilidade_whatsapp
      ? sensibilidade_whatsapp
      : [],
    status: status ? status : [],
    dataCadastroInicio: isValid(dataCadastroInicio)
      ? format(new Date(dataCadastroInicio), "yyyy-MM-dd")
      : null,
    dataCadastroFim: isValid(dataCadastroFim)
      ? format(new Date(dataCadastroFim), "yyyy-MM-dd")
      : null,
    dataCompraInicio: isValid(dataCompraInicio)
      ? format(new Date(dataCompraInicio), "yyyy-MM-dd")
      : null,
    dataCompraFim: isValid(dataCompraFim)
      ? format(new Date(dataCompraFim), "yyyy-MM-dd")
      : null,
    qtdeCompras: qtdeComprasInicio ? [qtdeComprasInicio, qtdeComprasFim] : [],
    valorCompras: valorComprasInicio
      ? [valorComprasInicio, valorComprasFim]
      : [],
    selectedProfissao: selectedProfissao
      ? selectedProfissao.map((pro) => pro.value)
      : [],
    selectedTagOrigem: selectedTagOrigem
      ? selectedTagOrigem.map((tag) => tag.origem_tag)
      : [],
    selectedDocumento: selectedDocumento
      ? selectedDocumento.map((doc) => doc.documento)
      : [],
    selectedMesNascimento: selectedMesNascimento
      ? selectedMesNascimento.map((mes) => mes.value)
      : [],
    celular: celular || celular === 0 ? celular : [],
    telefone: telefone || telefone === 0 ? telefone : [],
    endereco: endereco || endereco === 0 ? endereco : [],

    canalPreferecia: canalPreferecia ? canalPreferecia : [],
    canalAceito: canalAceito ? canalAceito : [],
    email: email || email === 0 ? email : [],

    categoria_1: categoria_1 ? categoria_1.map((grupo) => grupo.value) : [],
    categoria_2: categoria_2 ? categoria_2.map((familia) => familia.value) : [],
    categoria_3: categoria_3
      ? categoria_3.map((condicao) => condicao.value)
      : [],
    categoria_4: categoria_4 ? categoria_4.map((cor) => cor.value) : [],
    categoria_5: categoria_5
      ? categoria_5.map((fornecedor) => fornecedor.value)
      : [],
    categoria_6: categoria_6 ? categoria_6.map((colecao) => colecao.value) : [],
    categoria_7: categoria_7
      ? categoria_7.map((fornecedor) => fornecedor.value)
      : [],
    categoria_8: categoria_8 ? categoria_8.map((colecao) => colecao.value) : [],
    categoria_9: categoria_9
      ? categoria_9.map((fornecedor) => fornecedor.value)
      : [],
    categoria_10: categoria_10
      ? categoria_10.map((colecao) => colecao.value)
      : [],
    categoria_11: categoria_11
      ? categoria_11.map((colecao) => colecao.value)
      : [],
    categoria_12: categoria_12
      ? categoria_12.map((colecao) => colecao.value)
      : [],
    n_categoria_1: n_categoria_1
      ? n_categoria_1.map((grupo) => grupo.value)
      : [],
    n_categoria_2: n_categoria_2
      ? n_categoria_2.map((familia) => familia.value)
      : [],
    n_categoria_3: n_categoria_3
      ? n_categoria_3.map((condicao) => condicao.value)
      : [],
    n_categoria_4: n_categoria_4 ? n_categoria_4.map((cor) => cor.value) : [],
    n_categoria_5: n_categoria_5
      ? n_categoria_5.map((fornecedor) => fornecedor.value)
      : [],
    n_categoria_6: n_categoria_6
      ? n_categoria_6.map((colecao) => colecao.value)
      : [],
    n_categoria_7: n_categoria_7
      ? n_categoria_7.map((fornecedor) => fornecedor.value)
      : [],
    n_categoria_8: n_categoria_8
      ? n_categoria_8.map((colecao) => colecao.value)
      : [],
    n_categoria_9: n_categoria_9
      ? n_categoria_9.map((fornecedor) => fornecedor.value)
      : [],
    n_categoria_10: n_categoria_10
      ? n_categoria_10.map((colecao) => colecao.value)
      : [],
    pesquisa_1: pesquisa_1
      ? pesquisa_1.map((pesquisa) => pesquisa.RESPOSTA)
      : [],
    pesquisa_2: pesquisa_2
      ? pesquisa_2.map((pesquisa) => pesquisa.RESPOSTA)
      : [],
    pesquisa_3: pesquisa_3
      ? pesquisa_3.map((pesquisa) => pesquisa.RESPOSTA)
      : [],
    pesquisa_4: pesquisa_4
      ? pesquisa_4.map((pesquisa) => pesquisa.RESPOSTA)
      : [],
    pesquisa_5: pesquisa_5
      ? pesquisa_5.map((pesquisa) => pesquisa.RESPOSTA)
      : [],
    ticketMedio: ticketMedioInicio ? [ticketMedioInicio, ticketMedioFim] : [],
    diasCadastro: [diasCadastroInicio, diasCadastroFim],
    diasCompra: [diasCompraInicio, diasCompraFim],
    cashback: cashbackInicio ? [cashbackInicio, cashbackFim] : [],
    dataInicioVencimentoCashback: dataInicioVencimentoCashback,
    dataFimVencimentoCashback: dataFimVencimentoCashback,
    diasVencimentoCashback: diasVencimentoCashback,
    aniversarioHoje: aniversarioHoje,
    aniversarioMes: aniversarioMes,
    changeToRefetch: values.changeToRefetch,
  };

  return objParameters;
}
